import config from "./config";
var axios = config();

export default {
  getCourseSuggestions(subjectCode, catalogNumber, courseTitle) {
    return axios.get("/api/Classes/GetCourseSuggestions", {
      params: {
        subjectCode: subjectCode,
        catalogNumber: catalogNumber,
        courseTitle: courseTitle
      }
    });
  }
};
